import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IBranchesPayload, IInitialStateBranches} from "../types";
import {GetBranches, GetDeleteBranches} from "../store/thunk";


const initialState: IInitialStateBranches = {
    branches: [],
    branchesRestore: [],
    isViewBranchesRestore:false,
    isLoadingBranches:true,
    selectedBranchesIDs:[],
    filteredBranches:[]
}


const branchesSlice = createSlice({
    name: "branches",
    initialState,
    reducers: {
        setBranches: (state,action: PayloadAction<{data:IBranchesPayload[],defaultLanguage:string}>) => {

            const { data,defaultLanguage } = action.payload;
            state.branches = data
            state.filteredBranches = state.branches.flatMap((data) =>
                data.translations
                    .filter((elem) => elem.slug === defaultLanguage && elem.name)
                    .map((elem) => ({
                        id: data.id,
                        abbreviation: elem.abbreviation ?? '',
                        address: elem.address ?? '',
                        name: elem.name ?? '',
                    }))
            );

        },
        deletedRestoreBranches: (state, action) => {
            state.branchesRestore = state.branchesRestore.filter(
                (item) => item.id !== action.payload
            );
        },
        deleteBranches: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.branches = state.branches.filter(item => item.id !== id);
        },
        setSelectedBranchesIDs: (state, action) => {
            state.selectedBranchesIDs=action.payload
        },

        setBranchesRestore:(state,action)=>{
            state.branchesRestore = action.payload;
        },


        setIsViewBranchesRestore:(state)=>{

            state.isViewBranchesRestore =!state.isViewBranchesRestore;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(GetBranches.pending, (state) => {
                state.isLoadingBranches = true;
            })
            .addCase(GetBranches.fulfilled, (state) => {
                state.isLoadingBranches = false;
            })
            .addCase(GetBranches.rejected, (state) => {
                state.isLoadingBranches = false;
            })
            .addCase(GetDeleteBranches.pending, (state) => {
                state.isLoadingBranches = true;
            })
            .addCase(GetDeleteBranches.fulfilled, (state) => {
                state.isLoadingBranches = false;
            })
            .addCase(GetDeleteBranches.rejected, (state) => {
                state.isLoadingBranches = false;
            });
    },
})

export const {
    setBranches,
    deletedRestoreBranches,
    setSelectedBranchesIDs,
    deleteBranches,
    setBranchesRestore,
    setIsViewBranchesRestore,
} = branchesSlice.actions;

export default branchesSlice